module.exports = "<label>Blade Break In: </label>\r\n<span>{{(selectedResult?.BreakIn)}}</span>"